import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { FormWrapper } from '@/wrappers'
import type { ReferenceCode, FormData, FormInfo, DataFile, FormSelectOption, RequestType } from '@/interfaces'

export function useReferenceCode() {

    const baseForm: FormData = {
        company: null,
        contactPerson: null,
        object: null,
        price: null,
        services: null,
        notes: null
    };

    const route = useRoute();
    const wrapper = new FormWrapper<ReferenceCode>("reference-code");

    const empty = {...baseForm};

    const request = ref<RequestType<FormData>>({
        isLoading: false,
        error: null,
        response: null,
        data: baseForm
    });

    const info = ref<FormInfo>();
    const createdCode = ref<string|null>(null);
    const referenceCodes = ref<ReferenceCode[]>([]);
    const code = ref<string|string[]|null>(route.params.code);
    const referenceCode = ref<ReferenceCode>({} as ReferenceCode);

    const referenceCodeOptions = ref<FormSelectOption[]>([]);

    async function addCode(): Promise<void> {
        request.value = {...request.value , error: null , response: null , isLoading: !request.value.isLoading};

        await wrapper.addForm(getData()).then((data) => createdCode.value = data.message)
            .catch((err) => request.value.error = err.response.data.message);

        if (!request.value.error) {
            request.value.data = {...empty};
        }

        request.value.isLoading = !request.value.isLoading;
    }

    async function getCode(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getForm(code.value!, "code").then((data) => referenceCode.value = data)
            .catch((err) => request.value.error = err.response.data.message);

        request.value.isLoading = !request.value.isLoading;
    }

    async function getIndex(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getForms().then((data) => referenceCodes.value = data)
            .catch((err) => request.value.error = err.response.data.message);

        request.value.isLoading = !request.value.isLoading;
    }

    async function getInfo(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getInfo().then((data) => info.value = data).catch((err) => request.value.error = err.response.data.message);

        request.value.isLoading = !request.value.isLoading;
    }

    async function getReferenceOptions(): Promise<void> {
        await getIndex();

        referenceCodeOptions.value = referenceCodes.value.map(referenceCode => {
            return {
                value: referenceCode.fullCode,
                label: `${referenceCode.company.name}, ${referenceCode.object.name}`,
                command: referenceCode.fullCode,
            }
        });
    }

    function getData(): DataFile {
        return {
            file: null,
            data: JSON.stringify(request.value.data)
        }
    }

    return {
        info,
        request,
        createdCode,
        referenceCode,
        referenceCodes,
        referenceCodeOptions,
        addCode,
        getCode,
        getInfo,
        getIndex,
        getReferenceOptions
    };
}